import { Injectable } from '@angular/core';

import { interval, Observable, Subscription } from 'rxjs';
import { map, startWith, takeWhile } from 'rxjs/operators';

import dayjs from 'dayjs';

import { LanguageEnum } from '@api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class CountDownService {
  currentLang: string;

  private changesLanguage: Subscription;
  constructor(
    private translateService: TranslateService,
  ) {

    this.changesLanguage = this.translateService.onLangChange.subscribe(data => {
      this.currentLang = data.lang;
    })
  }

  countDown(timeInSeconds: number): Observable<number> {
    const beginningTime = new Date();

    return interval(1000).pipe(
      startWith(0),
      map(res => {
        const timeDiff = dayjs().diff(dayjs(beginningTime), 'seconds');
        return timeInSeconds - timeDiff;
      }),
      takeWhile(timeLeft => timeLeft >= 0),
      map(timeLeft => {
        return timeLeft;
      }),
    );
  }

  remain(timeInSeconds: number,
    format: 'human' | 'text' | 'digital' = 'digital',
    showAtLeast?: 'seconds' | 'minutes' | 'hours' | 'days'): Observable<string> {

    const beginningTime = new Date();

    return interval(1000).pipe(
      startWith(0),
      map(res => {
        const timeDiff = dayjs().diff(dayjs(beginningTime), 'seconds');
        // console.log('timeDiff -->', timeInSeconds - timeDiff);
        return timeInSeconds - timeDiff;
      }),
      takeWhile(timeLeft => timeLeft >= 0),
      map(timeLeft => {
        const days: any = Math.floor(timeLeft / 86400);
        const hours: any = Math.floor((timeLeft % 86400) / 3600);
        const minutes: any = Math.floor(((timeLeft % 86400) % 3600) / 60);
        const seconds: any = ((timeLeft % 86400) % 3600) % 60;

        return this.formatText(days, hours, minutes, seconds, format, showAtLeast);
      }),
    );
  }

  until(endTimestamp: number): Observable<string> {
    const time = dayjs(endTimestamp).diff(dayjs(), 'seconds');
    // console.log('minutes -->', time);
    return this.remain(time);
  }

  private formatText(days: any, hours: any, minutes: any, seconds: any, format: any, showAtLeast: any) {

    // reset
    if (days < 0) { days = 0; }
    if (hours < 0) { hours = 0; }
    if (minutes < 0) { minutes = 0; }
    if (seconds < 0) { seconds = 0; }

    // showAtLeast
    if (!showAtLeast) {
      if (format === 'digital') {
        showAtLeast = 'minutes';
      } else if (format === 'human') {
        showAtLeast = 'seconds';
      }
    }

    if (showAtLeast === 'seconds') {
      if (days <= 0 && hours <= 0 && minutes <= 0) { minutes = ''; }
      if (days <= 0 && hours <= 0) { hours = ''; }
      if (days <= 0) { days = ''; }
    }

    if (showAtLeast === 'minutes') {
      if (days <= 0 && hours <= 0) { hours = ''; }
      if (days <= 0) { days = ''; }
    }

    if (showAtLeast === 'hours') {
      if (days <= 0) { days = ''; }
    }

    // format
    if (format === 'digital') {
      if (seconds < 10) { seconds = '0' + seconds; }
      if (minutes !== '' && minutes < 10) { minutes = '0' + minutes; }
      if (hours !== '' && hours < 10) { hours = '0' + hours; }
      if (days !== '' && days < 10) { days = '0' + days; }

      if (minutes !== '') { minutes = minutes + ':'; }
      if (hours !== '') { hours = hours + ':'; }
      if (days !== '') { days = days + ':'; }
      return `${days}${hours}${minutes}${seconds}`;
    }

    if (format === 'human') {
      seconds = seconds + 's';
      if (minutes !== '') { minutes = minutes + 'm : '; }
      if (hours !== '') { hours = hours + 'h : '; }
      if (days !== '') { days = days + 'd : '; }
      return `${days}${hours}${minutes}${seconds}`;
    }

    if (format === 'text') {
      let textTime: any;
      // console.log('seconds -->', seconds);
      // console.log('minutes -->', minutes);
      if (seconds > 0) {
        textTime = `${this.currentLang === LanguageEnum.Th ? 'อีก' : 'in'} ${seconds} ${this.currentLang === LanguageEnum.Th ? 'นาที' : 'second'}`;
      }
      if (minutes > 0) {
        textTime = `${this.currentLang === LanguageEnum.Th ? 'อีก' : 'in'} ${minutes} ${this.currentLang === LanguageEnum.Th ? 'นาที' : 'minute'}`;
      }
      if (hours > 0) {
        textTime = hours > 0 ? `${this.currentLang === LanguageEnum.Th ? 'อีก' : 'in'} ${hours} ${this.currentLang === LanguageEnum.Th ? 'ชั่วโมง' : 'hour'}` : null;
      }
      if (days > 0) {
        textTime = `${this.currentLang === LanguageEnum.Th ? 'อีก' : 'in'} ${days} ${this.currentLang === LanguageEnum.Th ? 'วัน' : 'days'}`
      }

      return textTime
    }
    return 'unknown format';
  }

}
